export const OPEN = 'UPGRADE_OPEN';
export const CLOSE = 'UPGRADE_CLOSE';
export const RESET = 'UPGRADE_RESET';
export const SYNC = 'UPGRADE_SYNC_DATA';
export const REASON = 'UPGRADE_REASON';
export const PARTNER_FINDER_CONNECT = 'PARTNER_FINDER_CONNECT';
export const PARTNER_FINDER_SEARCH = 'PARTNER_FINDER_SEARCH';
export const CONTRACT_LIST_SENT_TRACKING = 'UPGRADE_CONTRACT_LIST_SENT_TRACKING';
export const WHO_VIEW_MY_PROFILE = 'UPGRDE_TO_SEE_WHO_VIEW_MY_PROFILE';
export const CONTRACTING_BOUNCED = 'UPGRDE_TO_SEE_BOUNCED_CONTRACT_OR_REQUEST';
export const CONTRACTING_REPORTS = 'UPGRADE_TO_DOWNLOAD_CONTRACTING_REPORTS';
export const CONTRACT_LIST_BULK_ACTIONS = 'CONTRACT_LIST_BULK_ACTIONS';



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/upgrade/upgrade-constants.js